import { useSelector } from 'react-redux';
import { Questionnaire } from '../../../../types';
import { selectQuestions } from '../../../../../../redux/questionnaire/selectors';
import { useEffect, useRef } from 'react';
import { groupQuestionsBySections } from '../utils';
import { UseFormSetValue } from 'react-hook-form';

export const useSyncQuestionnaireQuestions = (setValue: UseFormSetValue<Questionnaire>) => {
  const questions = useSelector(selectQuestions);
  const isInitialLoad = useRef(true);

  useEffect(() => {
    const updatedSections = groupQuestionsBySections(questions);

    if (isInitialLoad.current) {
      setValue('sections', updatedSections);
      isInitialLoad.current = false;
    } else {
      setValue('sections', updatedSections, { shouldDirty: true });
    }
  }, [questions, setValue]);
};
